import request from '../request'

// 获取消方列表
export function fetchList() {
    return request({
        url: 'finance-service/dictsales/list',
    })
}